import React, { useState, useEffect, useRef, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery, Tooltip } from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MailIcon from "@mui/icons-material/Mail";
import SearchIcon from "@mui/icons-material/Search";

import {
  AppBar,
  Toolbar,
  IconButton,
  MenuItem,
  Menu,
  Input,
  Button,
  Box,
  Badge,
  LinearProgress,
  Fade,
} from "@mui/material";

import Swal from "sweetalert2";

import { UserContext } from "../Context/Context";
import {
  AccountCircle,
  Business,
  ContactPhone,
  Mail,
} from "@mui/icons-material";
import api from "../../api/axios";

const Header = ({ handleToggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const navigate = useNavigate();
  const { logout } = useContext(UserContext);

  const { origin } = window.location;

  const [isSearching, setIsSearching] = useState(false);
  // -> Inicializamos como string "" para evitar confusiones de tipos
  const [queryFilter, setQueryFilter] = useState("");
  const [querySearch, setQuerySearch] = useState(""); // <-- ahora siempre string

  const [resultsClients, setResultsClients] = useState([]);
  const [resultsContacts, setResultsContacts] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [openMobileSearch, setOpenMobileSearch] = useState(false);

  const searchInfo = async (query) => {
    try {
      if (!query || query.trim() === "") {
        setResultsClients([]);
        setResultsContacts([]);
        return;
      }

      setIsSearching(true);

      const { data } = await api.get(
        `${
          process.env.REACT_APP_API_URL
        }/searchcontactsclientsinfo?search=${encodeURIComponent(query)}`,
      );

      setResultsClients(data.resultsClients || []);
      setResultsContacts(data.resultsContacts || []);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
      setResultsClients([]);
      setResultsContacts([]);
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    if (
      typeof querySearch === "string" &&
      querySearch.trim() !== "" &&
      querySearch.trim().length >= 3
    ) {
      const queryTimeOut = setTimeout(() => {
        setQueryFilter(querySearch.trim());
      }, 1500);

      searchInfo(querySearch.trim()); // <-- 🚨 Aquí llamas directo la búsqueda
      return () => clearTimeout(queryTimeOut);
    } else {
      setQueryFilter("");
      setResultsClients([]);
      setResultsContacts([]);
    }
  }, [querySearch]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        resultListRef.current &&
        !resultListRef.current.contains(event.target)
      ) {
        // ocultamos al hacer click fuera
        setQuerySearch("");
      }
    }

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const cerrarSesion = () => {
    logout(true);
  };

  const resultListRef = useRef(null);
  /* position: fixed; */
  /* z-index: 100; */
  /* width: 100%; */
  /* margin-bottom: 26px; */
  /* background: white; */
  /* box-shadow: 0px 0px 10px 4px gray;*/

  return (
    <div>
      <div className={"root"}>
        <AppBar
          position="static"
          color="default"
          sx={{ boxShadow: "0px 4px 10px rgba(0,0,0,0.2)" }}>
          <Toolbar>
            {/* HAMBURGUESA */}
            {isMobile && (
              <IconButton onClick={() => handleToggleSidebar(true)}>
                <MenuIcon />
              </IconButton>
            )}

            {/*  ICONO SEARCH (solo mobile) */}
            {isMobile && (
              <IconButton onClick={() => setOpenMobileSearch((prev) => !prev)}>
                <SearchIcon />
              </IconButton>
            )}

            {/*  SEARCH DESKTOP */}
            {!isMobile && (
              <div className="title containerGeneralSearch" style={{ flex: 1 }}>
                <Input
                  placeholder="Buscar contactos y clientes"
                  className="principalBrowser"
                  onChange={(event) => {
                    setQuerySearch(event.target.value);
                  }}
                  name="queryFilter"
                  autoComplete="off"
                  sx={{ width: "100%" }}
                  value={querySearch}
                />

                {isSearching && querySearch !== "" && (
                  <LinearProgress sx={{ width: "95%", mt: 1 }} />
                )}

                {!isSearching &&
                  (resultsClients.length > 0 || resultsContacts.length > 0) && (
                    <Fade in timeout={200}>
                      <Box ref={resultListRef} className="resultListStyles">
                        {[
                          ...resultsClients.map((r) => ({
                            ...r,
                            type: "Cliente",
                          })),
                          ...resultsContacts.map((r) => ({
                            ...r,
                            type: "Contacto",
                          })),
                        ].map((result) => (
                          <Box
                            key={`${result.type}-${result.id}`}
                            component="a"
                            href={`${origin}/${result.type.toLowerCase()}s/ver?id=${
                              result.id
                            }`}
                            sx={{
                              display: "block",
                              textDecoration: "none",
                              color: "inherit",
                              p: 1.2,
                              borderBottom: "1px solid #eee",
                              "&:hover": { backgroundColor: "#f5faff" },
                            }}>
                            <strong style={{ color: "#1976d2" }}>
                              {result.type}:
                            </strong>{" "}
                            {result.name} {result.surname}
                            <Box
                              sx={{
                                fontSize: "12px",
                                color: "#555",
                                mt: 0.5,
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 2, // separación uniforme entre items
                              }}>
                              {result.phone && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100px",
                                  }}>
                                  <ContactPhone
                                    sx={{ fontSize: 16, mr: 0.5 }}
                                  />
                                  {result.phone}
                                </Box>
                              )}

                              {result.email ? (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    minWidth: "250px",
                                    maxWidth: "600px",
                                  }}>
                                  <Mail sx={{ fontSize: 16, mr: 0.5 }} />
                                  {result.email}
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  Sin Email
                                </Box>
                              )}

                              {result?.company_relation?.company_name && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  <Business sx={{ fontSize: 16, mr: 0.5 }} />
                                  {result.company_relation.company_name.toUpperCase()}
                                </Box>
                              )}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Fade>
                  )}

                {!isSearching &&
                  querySearch !== "" &&
                  resultsClients.length === 0 &&
                  resultsContacts.length === 0 && (
                    <Box sx={{ fontSize: 13, color: "#999", mt: 1, px: 2 }}>
                      No se encontraron resultados
                    </Box>
                  )}
              </div>
            )}
            {/*  ICONOS DERECHA */}
            <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
              {!isMobile && (
                <Tooltip title="Esta función se encuentra deshabilitada temporalmente">
                  <span>
                    <IconButton sx={{ mr: 2 }} disabled>
                      <Badge badgeContent={4} color="error">
                        <MailIcon />
                      </Badge>
                    </IconButton>
                  </span>
                </Tooltip>
              )}

              <Tooltip title="Esta función se encuentra deshabilitada temporalmente">
                <span>
                  <IconButton sx={{ mr: 2 }} disabled>
                    <Badge badgeContent={17} color="error">
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>
                </span>
              </Tooltip>

              <IconButton onClick={handleMenu}>
                <AccountCircle />
              </IconButton>
            </Box>
            <div>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                open={open}
                onClose={handleClose}>
                <MenuItem onClick={handleClose}>
                  <NavLink to="/perfil">
                    <Button color="info">Mi Perfil</Button>
                  </NavLink>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <NavLink to="/perfil">
                    <Button>Mensajes</Button>
                  </NavLink>
                </MenuItem>
                <MenuItem onClick={handleClose}>
                  <NavLink to="/perfil">
                    <Button>Notificaciones</Button>
                  </NavLink>
                </MenuItem>
                <MenuItem onClick={cerrarSesion}>
                  <Button color="error">Cerrar Sesión</Button>
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    </div>
  );
};

export default Header;
